@if (state() === 'rehire-select') {
  <sb-dialog-header>
    <h1 sb-dialog-title>
      {{ 'Rehire former employee' | translate }}
    </h1>
  </sb-dialog-header>

  <sb-dialog-content>
    <p>
      {{
        "Select a deactivated employee to reactivate. You'll continue through the standard new hire steps, with details pre-filled."
          | translate
      }}
    </p>
    <sb-select
      [items]="inactiveEmployeesItems"
      [searchable]="true"
      [formControl]="rehireEmployeeControl"
      [inline]="true"
    >
      <ng-template #itemTemplate let-item="item">
        <div class="flex w-full justify-between gap-2">
          <div class="flex items-center gap-2">
            <sb-avatar
              [firstName]="item.employee.first_name"
              [lastName]="item.employee.last_name"
              [url]="item.employee.avatar"
              [size]="'base'"
              [colorSeed]="item.employee.id"
            ></sb-avatar>
            <span>{{ item.text }}</span>
          </div>
          @if (item.hasActiveRehire) {
            <sb-badge [color]="'yellow'" class="self-center">
              {{ 'Rehire started' | translate }}
            </sb-badge>
          } @else if (item.hasActiveContract) {
            <sb-badge [color]="'yellow'" class="self-center">
              {{ 'Active contract' | translate }}
            </sb-badge>
          }
        </div>
      </ng-template>
    </sb-select>
    <small class="mt-2 block text-support">
      {{
        'Not seeing someone? It may be due to permissions. Ask your admin for HR access, or add them as a new hire.'
          | translate
      }}
    </small>
  </sb-dialog-content>

  <sb-dialog-footer>
    <sb-dialog-footer-actions [align]="'end'">
      <button
        sb-button
        [color]="'primary'"
        [disabled]="!rehireEmployeeControl.value"
        (click)="onSelectRehireEmployee()"
      >
        {{ 'Continue' | translate }}
      </button>
    </sb-dialog-footer-actions>
  </sb-dialog-footer>
} @else if (state() === 'form') {
  <sb-dialog-header>
    <h1 sb-dialog-title>
      {{ 'Rehire former employee' | translate }}
    </h1>
  </sb-dialog-header>

  <sb-hire-form
    [form]="form"
    [hasContractTemplates]="hasContractTemplates"
    [showGuardianSignature]="guardianSignatureEnabled"
    [showGuardianCount]="guardianCountEnabled"
    [showGermanFields]="isGermanHire()"
    [teams]="teams()"
    [languages]="languages"
    [employmentCategoryItems]="employmentCategories()"
    (submitted)="submit()"
  />

  <sb-dialog-footer>
    <sb-dialog-footer-actions [align]="'end'">
      <button sb-button [color]="'primary'" [sbLadda]="loading()" (click)="submit()">
        {{ 'Send Invite' | translate }}
      </button>
    </sb-dialog-footer-actions>
  </sb-dialog-footer>
}
